import { FC } from 'react';

import { ReactComponent as SunSvgAsset } from './sun.svg';

export const SunSvg: FC<{ size: number; filter?: string }> = ({ size, filter }) => <SunSvgAsset width={size} height={size} style={{ filter }} />;
